import type { HTMLProps } from 'react'
import { wrapTextChildrenWithTypography } from '@/helpers/typography-wrapper'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { focusOutline, Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const TOP_NAVIGATION_BAR_ITEM_HEIGHT = '40px'

const TopNavigationBarItem = styled.button.attrs<HTMLProps<HTMLButtonElement>>(({ children }) => ({
  children: wrapTextChildrenWithTypography(children),
}))`
  display: flex;
  align-items: center;
  max-height: ${TOP_NAVIGATION_BAR_ITEM_HEIGHT};
  padding: ${space('primitives_space_12')};
  background: none;
  border: none;
  border-radius: ${tokPx('components_top_navigation_bar_menu_bar_item_corner_radius')};
  cursor: pointer;
  color: ${tok('semantics_text_color')};
  text-decoration: none;

  ${Typography} {
    ${Typography.modVariant('body-m-regular-tight')}
  }

  &:hover {
    background: ${tok('primitives_color_neutral_100')};
    color: inherit;
    text-decoration: none;
  }

  &:active {
    background: ${tok('primitives_color_neutral_150')};
    color: inherit;
    text-decoration: none;
  }

  ${focusOutline()}
`

export default TopNavigationBarItem
